import { useEffect } from 'react';
import {
  setIsDesktop,
  setIsPhone,
  setIsTablet,
  setIsSmallPhone,
  setIsSmallTablet,
  setIsMediumTablet,
  setIsLaptop,
  setIsLargeDesktopScreen,
} from 'redux/platformSlice';
import { useDispatch } from 'react-redux';

const usePlatform = () => {
  const dispatch = useDispatch();

  const signalPlatformSwitch = () => {
    if (typeof window !== 'undefined') {
      const screenWidth = window.innerWidth;
      const isSmallPhone = screenWidth <= 320;
      const isPhone = screenWidth <= 480;
      const isSmallTablet = screenWidth > 480 && screenWidth <= 580;
      const isMediumTablet = screenWidth > 480 && screenWidth <= 660;
      const isTablet = screenWidth > 480 && screenWidth <= 768;
      const isLaptop = screenWidth > 768 && screenWidth <= 1024;
      const isLargeScreen = screenWidth > 1440;

      if (isSmallPhone) {
        dispatch(setIsSmallPhone(isSmallPhone));
      } else if (isPhone) {
        dispatch(setIsPhone(isPhone));
      } else if (isSmallTablet) {
        dispatch(setIsSmallTablet(isSmallTablet));
      } else if (isMediumTablet) {
        dispatch(setIsMediumTablet(isMediumTablet));
      } else if (isTablet) {
        dispatch(setIsTablet(isTablet));
      } else if (isLaptop) {
        dispatch(setIsLaptop(isLaptop));
      } else if (isLargeScreen) {
        dispatch(setIsLargeDesktopScreen(isLargeScreen));
      } else {
        dispatch(setIsDesktop(true));
      }
    }
  };

  useEffect(() => {
    signalPlatformSwitch();

    window.addEventListener('resize', signalPlatformSwitch);

    return () => {
      window.removeEventListener('resize', signalPlatformSwitch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePlatform;
